import { AWSService } from 'services/awsServices'

export function handleError(error) {
  if (error?.response?.status === 401) {
    AWSService.logout()
    document.location.replace(`${document.location.origin}/`)
  }
}
